<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <!-- 头部：搜索条件 + 操作按钮 -->
      <template #header>
        <div>
          <!-- 第一行：搜索条件 -->
          <div class="flex flex-wrap align-items marginBottom20">
            <!-- 所属大区 -->
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >所属大区 :
              </span>
              <div class="width300">
                <el-select
                  v-model="searchData.region"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="item in regionList"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <!-- 关键字（人员姓名/工号） -->
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >关键字 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.keyword"
                  placeholder="人员姓名/工号"
                  clearable
                  maxlength="20"
                ></el-input>
              </div>
            </div>

            <!-- 重置按钮 -->
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="info" @click="handleReset"
                >重置</el-button
              >
            </div>

            <!-- 查询按钮 -->
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleSearch"
                >查询</el-button
              >
            </div>
          </div>

          <!-- 第二行：导入按钮 + 数量徽标 -->
          <div class="flex align-items marginBottom20">
            <el-button size="medium" type="primary" @click="handleImport"
              >导入审批人员</el-button
            >
          </div>
        </div>
      </template>

      <!-- 列：所属大区（枚举回显） -->
      <template slot="region" slot-scope="{ row }">
        {{ regionMap[row.region] || row.region || "-" }}
      </template>

      <!-- 列：操作（编辑 / 删除） -->
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleEdit(row)"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(row)"
          style="color: #ff001f !important"
          >删除</el-button
        >
      </template>
    </avue-crud>

    <!-- 编辑 审批人员 弹窗 -->
    <el-dialog
      v-if="dialogVisible"
      title="编辑审批人员"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <avue-form ref="form" v-model="form" :option="formOption">
        <!-- 姓名 -->
        <template slot="name">
          <el-input
            v-model="form.name"
            maxlength="20"
            placeholder="请输入"
            onkeyup="this.value=this.value"
            @blur="salaryDianChange($event, 'name')"
            type="text"
            clearable
          />
        </template>

        <!-- 工号 -->
        <template slot="jobNumber">
          <el-input
            v-model="form.jobNumber"
            maxlength="20"
            placeholder="请输入"
            onkeyup="this.value=this.value"
            @blur="salaryDianChange($event, 'jobNumber')"
            type="text"
            clearable
          />
        </template>

        <!-- 所属大区 -->
        <template slot="region">
          <el-select
            v-model="form.region"
            placeholder="请选择"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in regionList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </template>

        <!-- 表单底部按钮 -->
        <template slot="menuForm">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            @click="submit(form)"
            :loading="showLoadingForm"
            >保存</el-button
          >
        </template>
      </avue-form>
    </el-dialog>

    <!-- 导入审批人员 弹窗 -->
    <Import
      v-if="importShow"
      :show="importShow"
      :action="importAction"
      :downloadLink="importDownloadLink"
      :problemLink="importProblem"
      @close="importClose"
    />
  </div>
</template>

<script>
// OA审批人员相关接口（预览阶段：以下接口均为预估，待后端确认）
import {
  oaApproverList,
  oaApproverUpdate,
  oaApproverDelete,
  oaApproverRegionList,
} from "@/api/factory/oaApprover";
import Import from "@/components/import";

export default {
  name: "index",
  components: { Import },
  data() {
    return {
      regionList: [], // 大区选项数组（{value,label}）
      regionMap: {}, // 大区映射，用于列表回显
      // 搜索条件
      searchData: {
        region: "", // 所属大区
        keyword: "", // 关键字：姓名/工号
      },
      // 分页参数
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], // 列表数据
      showLoading: false, // 列表加载中
      showLoadingForm: false, // 表单提交中（防重提交）
      dialogVisible: false, // 编辑弹窗显隐

      // 表格配置
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false, // 隐藏自带编辑按钮
        delBtn: false, // 隐藏自带删除按钮
        selection: false,
        tip: false,
        column: [
          {
            label: "姓名",
            prop: "name",
          },
          {
            label: "工号",
            prop: "jobNumber",
          },
          {
            label: "所属大区",
            prop: "region",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
        ],
      },

      // 表单数据
      form: {
        name: "", // 姓名
        jobNumber: "", // 工号
        region: "", // 所属大区
      },

      // 表单配置
      formOption: {
        submitBtn: false,
        emptyBtn: false,
        labelWidth: "120",
        row: true,
        column: [
          {
            label: "姓名",
            prop: "name",
            type: "text",
            maxlength: 20,
            placeholder: "请输入",
            span: 24,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "工号",
            prop: "jobNumber",
            type: "text",
            maxlength: 20,
            placeholder: "请输入",
            span: 24,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "所属大区",
            prop: "region",
            type: "text",
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择",
                trigger: "change",
              },
            ],
          },
        ],
      },

      // 导入相关（预览阶段：接口路径均为预估，待后端确认）
      importShow: false, // 导入弹窗
      importAction: "/api/web/auditor/template/import", // 上传地址
      importDownloadLink: "/web/auditor/template/export", // 模板下载
      importProblem: "/web/auditor/template/error/export", // 问题数据下载
    };
  },
  created() {
    this.getRegionList();
  },
  methods: {
    // 列表初始化 / 分页变更回调
    onLoad() {
      this.showLoading = true;
      oaApproverList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      })
        .then((res) => {
          this.showLoading = false;
          if (res.code === 200) {
            const data = res.data || {};
            this.tableData = data.records || [];
            this.page.total = data.total || 0;
          }
        })
        .catch(() => {
          this.showLoading = false;
        });
    },

    // 查询
    handleSearch() {
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 重置
    handleReset() {
      this.searchData = {
        region: "",
        keyword: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 获取
    getRegionList() {
      oaApproverRegionList().then((res) => {
        if (res.code === 200) {
          this.regionList = (res.data || []).map((item) => ({
            label: item,
            value: item,
          }));
          this.regionMap = this.regionList.reduce((map, item) => {
            map[item.value] = item.label;
            return map;
          }, {});
        }
      });
    },

    // 编辑审批人员
    handleEdit(row) {
      this.form = {
        id: row.id,
        name: row.name,
        jobNumber: row.jobNumber,
        region: row.region,
      };
      this.dialogVisible = true;
    },

    // 删除审批人员
    handleDelete(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        oaApproverDelete(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
            this.getRegionList();
          }
        });
      });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },

    // 重置表单
    resetForm() {
      this.form = {
        id: "",
        name: "",
        jobNumber: "",
        region: "",
      };
    },

    // 输入框失焦时同步表单字段（兼容 onkeyup 处理后的值）
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    // 表单提交（编辑）
    submit(form) {
      this.$refs.form.$refs.form.validate((valid) => {
        if (!valid) return;
        if (this.showLoadingForm) return;
        this.showLoadingForm = true;

        oaApproverUpdate({ ...form })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("操作成功");
              this.dialogVisible = false;
              setTimeout(() => {
                this.resetForm();
              }, 500);
              this.onLoad();
              this.getRegionList();
            }
            this.showLoadingForm = false;
          })
          .catch(() => {
            this.showLoadingForm = false;
          });
      });
    },

    // 打开导入弹窗
    handleImport() {
      this.importShow = true;
    },

    // 关闭导入弹窗（导入完成后刷新列表）
    importClose() {
      this.importShow = false;
      this.onLoad();
      this.getRegionList();
    },
  },
};
</script>

<style scoped>
.approver-badge >>> .el-badge__content {
  top: 6px;
  right: 12px;
  background-color: #f59a23;
  border-color: #f59a23;
  color: #fff;
}
</style>
